<script>
export default {
  props: {
    ln: {
      type: String
    },
    la: {
      type: String
    },
    addr: {
      type: String
    }
  },
  mounted() {
    this.initMap()
  },
  methods: {
    initMap() {
      window._AMapSecurityConfig = {
        securityJsCode: 'ca52de5f30db4f525aa94ad6d2e42d11'
      }
      AMapLoader.load({
        key: '144083138e65143bef786f3846928cc4', //申请好的Web端开发者 Key，调用 load 时必填
        version: '2.0', //指定要加载的 JS API 的版本，缺省时默认为 1.4.15
        plugins: ['AMap.Scale', 'AMap.ToolBar', 'AMap.ControlBar']
      })
        .then((AMap) => {
          const map = new AMap.Map(this.$refs.container, {
            center: [this.ln, this.la],
            zoom: 18
          })
          const toolBar = new AMap.ToolBar({
            position: {
              top: '110px',
              right: '40px'
            }
          })
          const controlBar = new AMap.ControlBar({
            position: {
              top: '10px',
              right: '10px'
            }
          })
          const marker = new AMap.Marker({
            position: new AMap.LngLat(this.ln, this.la)
          })
          marker.on('click', () => {
            const infoWindow = new AMap.InfoWindow({
              content: `
                <div style="font-size: 12px;width: 150px">
                <div><span>地理位置</span></div>
                <div><span>${this.addr}</span></div>
                <div><span>经度：${this.ln}</span></div>
                <div><span>纬度：${this.la}</span></div>
</div>
              `, //传入字符串拼接的 DOM 元素
              anchor: 'top-left'
            })
            infoWindow.open(map, new AMap.LngLat(this.ln, this.la))
            const close = ()=>{
              infoWindow.close()
              map.off('click',close)
            }
            map.on("click",close)
          })
          map.addControl(toolBar)
          map.addControl(controlBar)
          map.add(marker)
        })
        .catch((e) => {
          console.error(e) //加载错误提示
        })
    }
  }
}
</script>

<template>
  <div ref="container"></div>
</template>

<style lang="scss">
.amap-copyright,.amap-logo {
  display: none !important;
}
</style>
